import { ARRAY_ERROR } from 'final-form';

type ArrayWithError = unknown[] & { [ARRAY_ERROR]?: string };

/**
 * Аналог JSON.parse(JSON.stringify(...)) для объекта ошибок формы,
 * но с сохранением служебного свойства ARRAY_ERROR у массивов.
 *
 * JSON-сериализация выбрасывает все неиндексные свойства массива, из-за чего
 * ошибки уровня массива (getArrayError) молча терялись, и поле считалось валидным.
 */
const cloneValue = (value: unknown): unknown => {
  if (Array.isArray(value)) {
    const result = value.map(item =>
      item === undefined || typeof item === 'function' ? null : cloneValue(item),
    ) as ArrayWithError;

    const arrayError = (value as ArrayWithError)[ARRAY_ERROR];

    if (arrayError !== undefined) {
      result[ARRAY_ERROR] = arrayError;
    }

    return result;
  }

  if (value !== null && typeof value === 'object') {
    const result: Record<string, unknown> = {};

    Object.entries(value as Record<string, unknown>).forEach(([key, item]) => {
      if (item === undefined || typeof item === 'function') {
        return;
      }

      result[key] = cloneValue(item);
    });

    return result;
  }

  return typeof value === 'function' ? undefined : value;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const cloneFormErrors = (value: unknown): any => cloneValue(value);
